module.exports = __webpack_public_path__ + "img/Pie-chart-icon.f05cad92.svg";